module.exports = __parcel__import__.meta.resolve("k6H04");